<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard>
                <CCardHeader>
                    <strong>Коды верификации</strong>
                </CCardHeader>
                <CCardBody>
                    <CDataTable
                        hover
                        column-filter
                        sorter
                        :items="items"
                        :fields="fields"
                        :items-per-page="10"
                        :active-page="activePage"
                        :pagination="{ doubleArrows: true, align: 'center'}"
                        @page-change="pageChange"
                    >
                        <template #customer="data">
                            <td>
                                <CLink
                                    :to="`/customers/${data.item.customer.id}`"
                                >{{ data.item.customer.phone + ' ' + data.item.customer.firstname + ' ' + data.item.customer.lastname }}</CLink>
                            </td>
                        </template>
                        <template #created_at="data">
                            <td>{{ formatDate(data.item.created_at) }}</td>
                        </template>
                        <template #updated_at="data">
                            <td>{{ formatDate(data.item.updated_at) }}</td>
                        </template>
                        <template #active="data">
                            <td>
                                <CBadge
                                    :color="getBadge(data.item.active)"
                                >&nbsp;{{ data.item.active ? 'Да' : 'Нет' }}&nbsp;</CBadge>
                            </td>
                        </template>
                    </CDataTable>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    const { formatDate } = require('../../utils/views');

    export default {
        name: 'VerificationCodes',

        data() {
            return {
                items: [],
                fields: [
                    { key: 'id', label: 'ID', _classes: 'font-weight-bold' },
                    { key: 'customer', label: 'Клиент' },
                    { key: 'code', label: 'Код' },
                    { key: 'sent_at', label: 'Отправлен' },
                    { key: 'attempts', label: 'Количество попыток' },
                    { key: 'active', label: 'Активен' },
                    { key: 'created_at', label: 'Создан' },
                    { key: 'updated_at', label: 'Обновлен' },
                ],
                activePage: 1,
            };
        },

        computed: {},

        watch: {
            $route: {
                immediate: true,
                handler(route) {
                    if (route.query && route.query.page) {
                        this.activePage = Number(route.query.page);
                    }
                },
            },
        },

        mounted() {
            Vue.axios
                .get('/verification-codes')
                .then(resp => {
                    this.items = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            formatDate(ISOString) {
                return formatDate(ISOString);
            },
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            pageChange(val) {
                this.$router.push({ query: { page: val } });
            },
        },
    };
</script>
